import React from 'react';
import { motion } from 'framer-motion';

const SectionHeader = ({
  badge,
  title,
  accentWord,
  subtitle,
  variant = 'light',
  align = 'center',
  className = '',
}) => {
  const isDark = variant === 'dark';
  const isCentered = align === 'center';

  const renderTitle = () => {
    if (!accentWord) return title;
    const idx = title.indexOf(accentWord);
    if (idx === -1) return title;
    return (
      <>
        {title.slice(0, idx)}
        <span className={isDark ? 'text-secondary-400' : 'text-secondary-500'}>
          {accentWord}
        </span>
        {title.slice(idx + accentWord.length)}
      </>
    );
  };

  return (
    <motion.div
      className={`${isCentered ? 'text-center' : 'text-left'} ${className}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
    >
      {badge && (
        <span
          className={[
            'inline-flex items-center gap-1.5',
            'text-xs font-semibold uppercase tracking-widest',
            'px-4 py-1.5 rounded-full mb-4',
            isDark
              ? 'bg-white/10 backdrop-blur-sm border border-white/15 text-secondary-400'
              : 'bg-secondary-100 text-secondary-700',
          ].join(' ')}
        >
          {badge}
        </span>
      )}

      <h2
        className={[
          'font-bold font-quicksand leading-tight mb-3',
          isDark ? 'text-white' : 'text-primary-900',
        ].join(' ')}
        style={{ fontSize: 'clamp(1.75rem, 2.8vw + 1rem, 3rem)' }}
      >
        {renderTitle()}
      </h2>

      <div className={isCentered ? 'flex justify-center mb-4' : 'flex justify-start mb-4'}>
        <div
          style={{
            width: '72px',
            height: '3px',
            borderRadius: '9999px',
            background: isDark
              ? 'linear-gradient(90deg, #94DDB8, #3DAA6B, #1B6039)'
              : 'linear-gradient(90deg, #3DAA6B, #2E8B54, #94DDB8)',
          }}
        />
      </div>

      {subtitle && (
        <p
          className={[
            'text-base lg:text-lg leading-relaxed',
            isCentered ? 'max-w-2xl mx-auto' : 'max-w-xl',
            isDark ? 'text-white/60' : 'text-neutral-500',
          ].join(' ')}
        >
          {subtitle}
        </p>
      )}
    </motion.div>
  );
};

export default SectionHeader;
